// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fontNormal[data-v-66d059e1]{\n  font-weight: 400;\n  font-size: 14px;\n}\n.shadowCard[data-v-66d059e1]{\n  border-bottom-right-radius: 8px;\n  border-bottom-left-radius: 8px;\n  border: .5px solid transparent\n}\n", ""]);
// Exports
module.exports = exports;
